export class Utils {
  static getPaginatedItems<T>(array: T[], itemsPerPage: number, currentPage: number) {
    // Ensure currentPage starts from 1 (not 0)
    if (currentPage < 1) {
      throw new Error('currentPage must be 1 or greater');
    }

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    return array.slice(startIndex, endIndex);
  }
}
